import { render, staticRenderFns } from "./ModalSelectWasteOrServiceModalForSchedule.vue?vue&type=template&id=487ff91e&scoped=true&"
import script from "./ModalSelectWasteOrServiceModalForSchedule.vue?vue&type=script&lang=js&"
export * from "./ModalSelectWasteOrServiceModalForSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ff91e",
  null
  
)

export default component.exports